import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=ed47bdb4&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=ed47bdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed47bdb4",
  null
  
)

export default component.exports